import React from "react";
import './VisaProc.css';

const VisaProc = () => {
    return(
        <div>
            <div className="sectiontitle">Visa <span>Process</span></div>
            <div className="visa-proc-card-container" style={{width:'100%',display:'flex',justifyContent:'space-between',flexDirection:'row'}}>
                <div className="visa-proc-card">
                    <div style={{fontSize:'22px',fontWeight:'500'}}>Step 1</div>
                    <div style={{fontSize:'20px',fontWeight:'500'}}>Fill Application</div>
                    <div>Complete the visa application form with your details and preferred travel plans.</div>
                </div>

                <div className="visa-proc-card">
                    <div style={{fontSize:'22px',fontWeight:'500'}}>Step 2</div>
                    <div style={{fontSize:'20px',fontWeight:'500'}}>Upload Documents</div>
                    <div>Upload all required documents to support your visa application.</div>
                </div>

                <div className="visa-proc-card">
                    <div style={{fontSize:'22px',fontWeight:'500'}}>Step 3</div>
                    <div style={{fontSize:'20px',fontWeight:'500'}}>Make Payment</div>
                    <div>Complete the visa application form with your details and preferred travel plans.</div>
                </div>

                <div className="visa-proc-card">
                    <div style={{fontSize:'22px',fontWeight:'500'}}>Step 4</div>
                    <div style={{fontSize:'20px',fontWeight:'500'}}>Track & Receive Visa</div>
                    <div>UMonitor your application status in real-time and receive your visa upon approval.</div>
                </div>
                
                
            </div>
        </div>
    )
}

export default VisaProc;